import React, {Component} from 'react';

//CSS
import './NavSocial.css';
import whatsapp from '../../assets/img/iconRedes/wp.png';
import face from '../../assets/img/iconRedes/face.png';


class NavSocial extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div>
                <div className="icon-container">
                    <a alt="Chatea con nosotros" href="https://api.whatsapp.com/send?phone=5493412153690"
                       target="_blank">
                        <img className="img-responsive" src={whatsapp} alt=""/>
                    </a>
                    {/*<a alt="Hablá con nosotros" href="http://m.me/myfdistribucioness/" target="_blank">*/}
                    {/*    <img className="img-responsive" src={face} alt=""/>*/}
                    {/*</a>*/}
                </div>
            </div>
        );
    }
}


export default NavSocial;



// WEBPACK FOOTER //
// ./src/layout/NavSocial/NavSocial.js